import Vue from 'vue';

const state = {
  tutorias : [],
  cursos: {}
};

const actions = {
  
  fetchTutorias:({commit}) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutorias').then(
        response =>{
          commit('setTutorias',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        console.error(response);
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  fetchTutoria:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria',data).then(
        response =>{
          commit('setTutoria',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  fetchCurso:({commit},curso_id) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('temas',{id:curso_id}).then(
        response =>{
          commit('setCurso',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  saveAsistencia:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/asistencia',data).then(
        response =>{
          commit('setAgendamiento',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  saveObservacion:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/observacion',data).then(
        response =>{
          commit('setAgendamiento',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  saveNovedad:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/novedad',data).then(
        response =>{
          commit('setAgendamiento',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  cambiarTipo:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/cambiar_tipo',data).then(
        response =>{
          commit('setAgendamiento',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  saveTema:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/tema',data).then(
        response =>{
          commit('setAgendamiento',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  
};

const getters = {
  getCurso: (state) => (curso_id) => {
    if(!state.cursos[curso_id]){
      Vue.set(state.cursos, curso_id, {})
    }
    return state.cursos[curso_id]
  },
};

const mutations = {
  setTutorias: (state, datos) => {
    state.tutorias = datos
  },
  setTutoria: (state, datos) => {
    if(datos.id){
      let index = state.tutorias.findIndex(element =>{
        return element.id == datos.id
      })
      if(index>=0){ 
        state.tutorias.splice(index,1,datos)
      }else{
        state.tutorias.push(datos)
      }
    }
    
  },
  setCurso : (state, datos) => {
    let id = datos.id
    if(!state.cursos[datos.id]){
      Vue.set(state.cursos, datos.id, {})  
    }
    state.cursos[datos.id] = datos
    
  },
  setAgendamiento: (state, datos) => {
    
    if(datos.clase_auxiliar_id){
      let clase = state.tutorias.find(element =>{
        return element.id == datos.clase_auxiliar_id
      })
      let index = clase.estudiantes.findIndex(element =>{
        return element.id == datos.id
      })
      if(index>=0){
        clase.estudiantes.splice(index,1,datos)
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
